import { Path } from 'react-hook-form';

import { ErrorResponse, InputId } from 'components/actionModal/models';

export enum AccountModalWindowStages {
  SelectType = 'SELECT_TYPE',
  AccountDetails = 'ACCOUNT_DETAILS',
  // PrimaryContact = 'PRIMARY_CONTACT',
  Result = 'RESULT',
}

export enum AccountCategory {
  Group = 'GROUP',
}

export type CorporateAccountDetailsData = {
  companyName: string;
  website: string;
  businessSector: string;
  country: {
    abbr: string;
    displayName: string;
  };
};

export type CorporatePrimaryContactData = {
  firstName: string;
  lastName: string;
  role: string;
  email: string;
  mobile: {
    code: string;
    number: string;
  };
};

export enum QueryKey {
  GetCorporateAccounts = 'GET_CORPORATE_ACCOUNTS',
}

export const ACCOUNTS_SORT_BY_BE = ['Alphabetical', 'Latest'];
export const ACCOUNTS_SORT_BY_FE = ['A-Z', 'Latest'];

export const createCorporateAccountErrorResponse: Partial<ErrorResponse> = {
  GROUP_NAME_TAKEN: 'corporateAccount/corporate-account-name-is-not-unique',
};

export type CorporateAccountFormValues = {
  [InputId.CompanyNameInputId]: string;
  [InputId.BusinessSectorInputId]: string;
};

export type CorporateAccountMutationError = {
  input: Path<CorporateAccountFormValues>;
  message: string;
};

export type ServerErrorPayload = {
  payload?: {
    message?: string;
  };
};
